import React from "react";
import ListIcon from "@material-ui/icons/List";

function ListViewIcon() {
  return <ListIcon />;
}
export default ListViewIcon;
